import { useEffect, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { handleShowContextualLoader, handlehideContextualLoader } from "../../utils/contextualLoaderTrigger";
import { getToken } from "../../utils/storage";
import EMIsAPI from "../../services/emi-api";

const LmsRedirection = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const api = useMemo(() => new EMIsAPI(), []);

  const token = getToken();
  const lms_id = searchParams.get("lms_id");
  const order_id = searchParams.get("order_id");
  const handleRedirection = (url = "/") => {
    navigate(url, { replace: true });
  };

useEffect(() => {
  let interval;
  let timeout;

  const fetchData = async () => {
    try {
      if (!token) {
        handleRedirection();
        return;
      }

      handleShowContextualLoader("Getting your loan details");

      const checkStatus = async () => {
        try {
          const response = await api.repaymentFallbackAPI(lms_id, order_id);

          if (!response?.data?.inProgress) {
            clearInterval(interval);
            clearTimeout(timeout);
            handlehideContextualLoader();
            handleRedirection("/");
          }
        } catch (err) {
          clearInterval(interval);
          clearTimeout(timeout);
          handlehideContextualLoader();
          handleRedirection("/");
        }
      };


      await checkStatus();


      interval = setInterval(checkStatus, 5000);

      timeout = setTimeout(() => {
  handlehideContextualLoader();
  navigate(`/payment-pending?lms_id=${lms_id}`, {
    replace: true,
  });
  }, 3 * 60 * 1000);

    } catch (error) {
      handlehideContextualLoader();
      handleRedirection("/");
    }
  };

  fetchData();

  return () => {
    if (interval) clearInterval(interval);
    if (timeout) clearTimeout(timeout);
  };

}, [token, lms_id, order_id]);

  return null;
};

export default LmsRedirection;